var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
import MandatoryIndicator from "./MandatoryIndicator";
import _ from "lodash";
import ErrorLabel from "./ErrorLabel";
import { firstError } from "../../Services/Form";
const StyledInputWrapper = styled.div `
    position: relative;
    margin-bottom: 8px;

    &:first-child&:last-child {
        margin: 0;
    }
`;
const StyledInput = styled.input `
    position: absolute;
    top: 5px;
    left: 3px;
    margin: 0;
    padding: 0;
    height: auto;
    width: auto !important;

    &:checked + label {
        color: ${(props) => props.theme.primary};

        &:before {
            border-color: ${(props) => props.theme.primary};
            background-color: ${(props) => props.theme.primary};
        }
        &:after {
            opacity: 1;
        }
    }

    &:checked ~ a {
        color: ${(props) => props.theme.primary};
    }

    &:checked:disabled + label {
        color: #a0a0a0;

        &:before {
            background-color: #a0a0a0;
            border-color: #a0a0a0;
        }
    }
`;
const StyledLabel = styled.label `
    transition: color 0.2s ease-in-out;
    padding-left: 25px;
    vertical-align: middle;
    color: ${(props) => props.theme.textBase};
    cursor: pointer;
    font-size: 15px;
    font-weight: ${(props) => {
    if (props.isBold) {
        return "700";
    }
    return "400";
}};

    &:before {
        transition: border-color 0.2s ease-in-out;
        position: absolute;
        content: "";
        width: 17px;
        height: 17px;
        left: 0;
        top: 0;
        border-radius: 2px;
        background-color: #ffffff;
        border: 1px solid ${color.gray.light};
    }

    &:after {
        transition: opacity 0.2s ease-in-out;
        position: absolute;
        content: "";
        width: 13px;
        height: 12px;
        left: 3px;
        top: 5px;
        background-repeat: no-repeat;
        background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zOmNjPSJodHRwOi8vY3JlYXRpdmVjb21tb25zLm9yZy9ucyMiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6aW5rc2NhcGU9Imh0dHA6Ly93d3cuaW5rc2NhcGUub3JnL25hbWVzcGFjZXMvaW5rc2NhcGUiIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6c29kaXBvZGk9Imh0dHA6Ly9zb2RpcG9kaS5zb3VyY2Vmb3JnZS5uZXQvRFREL3NvZGlwb2RpLTAuZHRkIiB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDc4LjMgNTQuMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNzguMyA1NC4xOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0ZGRkZGRjt9PC9zdHlsZT48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLC05NTIuMzYyMTgpIj48cGF0aCBjbGFzcz0ic3QwIiBkPSJNNzEuMSw5NTIuNGMtMS44LDAuMS0zLjUsMC44LTQuOCwyLjFsLTM1LjYsMzUuNkwxMS41LDk3NWMtMi45LTIuNS03LjQtMi4yLTkuOSwwLjhzLTIuMiw3LjQsMC44LDkuOWMwLjEsMC4xLDAuMywwLjIsMC40LDAuM2wyNCwxOWMyLjgsMi4yLDYuOCwyLDkuMy0wLjVsNDAtNDBjMi44LTIuNywyLjktNy4xLDAuMi05LjlDNzQuOSw5NTMuMSw3Myw5NTIuMyw3MS4xLDk1Mi40TDcxLjEsOTUyLjR6Ii8+PC9nPjwvc3ZnPg==);
        opacity: 0;
    }
`;
const InputCheckbox = (_a) => {
    var { label, id, children, tooltipContents, className, isBold, error, isMandatory } = _a, restProps = __rest(_a, ["label", "id", "children", "tooltipContents", "className", "isBold", "error", "isMandatory"]);
    error = typeof error === "object" ? firstError(error) : error;
    const [fid] = useState(id || _.uniqueId("field-"));
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledInputWrapper, { className: className },
            React.createElement(StyledInput, Object.assign({ type: "checkbox", id: fid }, restProps)),
            React.createElement(StyledLabel, { htmlFor: fid, isBold: isBold, tooltipContents: tooltipContents },
                label,
                (isMandatory || restProps.required) && (React.createElement(MandatoryIndicator, null))),
            children),
        !!error && React.createElement(ErrorLabel, null, _.capitalize(error))));
};
export default InputCheckbox;
